import { getStoreId } from "$/hooks/use-store-information"
import washQueries from "$/lib/queries/wash-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/settings/wash")({
  loader: async ({ context: { queryClient } }) => {
    const storeId = await getStoreId()
    if (storeId) queryClient.prefetchQuery(washQueries.list({ storeId }))
    return {
      crumbs: "alfred.settings.nav.wash.label",
    }
  },
})
